// extracted by mini-css-extract-plugin
export default {"line":"statusCommissions_line__wFB23","title":"statusCommissions_title__ECvd8","dot":"statusCommissions_dot__5MZKO"};